export default __webpack_public_path__ + "static/media/image.0b6f715f.png";